import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from './style'

import { defaultThreatsOptions } from './Threats'

const RemoveThreatModal = ({ closeModal, confirmRemove, item, threatsList }) => {
  const resolvedThreatsList = threatsList || defaultThreatsOptions
  const threatItemId = item?.Level3ThreatId ? item.Level3ThreatId : item?.Level2ThreatId
  const threats = item?.Level3ThreatId
    ? resolvedThreatsList?.level3Threats
    : resolvedThreatsList?.level2Threats
  const name = Array.isArray(threats)
    ? threats.find((element) => element.value === threatItemId)
    : null

  return (
    <>
      <RemoveItemModalText data-test="modal-body">
        <FormattedMessage id="removeModalText" values={{ name: <b>{name ? name.label : item?.name}</b> }} />
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

export default RemoveThreatModal
